export default __webpack_public_path__ + "static/media/360.636e9ea6.svg";